import { Link } from "react-router-dom";
import { IconType } from "react-icons";
import { LuArrowRight } from "react-icons/lu";

export type Stat = {
  icon: IconType;
  label: string;
  value: string;
  unit: string;
};

export const StatCard = ({ icon: Icon, label, value, unit }: Stat) => {
  return (
    <article className="card flex flex-col gap-5 p-5 md:p-6">
      <div className="flex items-center gap-3">
        <Icon className="text-2xl text-brand" aria-hidden />
        <p className="text-neutral-400">{label}</p>
      </div>
      <div className="flex justify-between md:flex-col gap-2 md:gap-5">
        <p className="text-4xl font-bold text-white">
          {value}{" "}
          <span className="text-base font-normal text-neutral-400">{unit}</span>
        </p>
        <Link to="/dashboard" className="link-brand mt-auto">
          Детальніше <LuArrowRight aria-hidden />
        </Link>
      </div>
    </article>
  );
};
